import { render, staticRenderFns } from "./UrlWithQrCode.vue?vue&type=template&id=73db07f4&"
import script from "./UrlWithQrCode.vue?vue&type=script&lang=ts&"
export * from "./UrlWithQrCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports